import type { MrFriend } from './runtime/net/mysteryRoomApi';

const MYSTERY_ROOM_GAME_ID = 'mystery-room';

export function isMysteryRoomFriendPlaying(friend: Pick<MrFriend, 'is_online' | 'game_presence'>): boolean {
  return !!friend.is_online && friend.game_presence?.game_id === MYSTERY_ROOM_GAME_ID;
}

export function formatMysteryRoomFriendPresence(friend: Pick<MrFriend, 'is_online' | 'game_presence'>): string {
  const presence = friend.game_presence;
  if (presence?.game_id === MYSTERY_ROOM_GAME_ID) {
    return presence.detail || presence.state_label || `Играет в ${presence.game_title || 'Mystery Room'}`;
  }
  return friend.is_online ? 'в сети' : 'не в сети';
}

export function sortMysteryRoomFriends<T extends MrFriend>(friends: T[]): T[] {
  return friends.slice().sort((a, b) => {
    const aPlaying = isMysteryRoomFriendPlaying(a) ? 1 : 0;
    const bPlaying = isMysteryRoomFriendPlaying(b) ? 1 : 0;
    if (aPlaying !== bPlaying) return bPlaying - aPlaying;

    const aOnline = a.is_online ? 1 : 0;
    const bOnline = b.is_online ? 1 : 0;
    if (aOnline !== bOnline) return bOnline - aOnline;

    const aName = a.display_name || a.username || '';
    const bName = b.display_name || b.username || '';
    return aName.localeCompare(bName, 'ru');
  });
}
